import type { TaskListCatalog } from '@techgitter/contracts';

const API_BASE_URL = '/api';

export async function getTaskLists(signal?: AbortSignal): Promise<TaskListCatalog> {
  const response = await fetch(`${API_BASE_URL}/task-lists`, {
    method: 'GET',
    headers: { 'Accept': 'application/json' },
    signal,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch task lists: ${response.status} ${response.statusText}`);
  }

  return response.json();
}

export async function putTaskLists(
  catalog: TaskListCatalog,
  signal?: AbortSignal
): Promise<TaskListCatalog> {
  const response = await fetch(`${API_BASE_URL}/task-lists`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(catalog),
    signal,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({
      error: `Failed to save task lists: ${response.status}`,
    }));
    throw new Error(errorData.error || `Failed to save task lists: ${response.status}`);
  }

  return response.json();
}

export async function clearTaskListsCache(signal?: AbortSignal): Promise<{ cleared: boolean }> {
  const response = await fetch(`${API_BASE_URL}/task-lists/cache/clear`, {
    method: 'POST',
    signal,
  });

  if (!response.ok) {
    throw new Error(`Failed to clear task lists cache: ${response.status}`);
  }

  return response.json();
}
